<div mat-dialog-content>
  <div>
    <h2>Fjern selger</h2>
    <p>Sikker på at du vil fjerne selger {{ data.seller.fullName }}?</p>
  </div>
</div>

<div class="dialog-buttons" mat-dialog-actions>
  <app-ice-button
    class="button"
    color="secondary"
    testId="confirm-remove-seller-button"
    width="100%"
    (click)="confirmRemove()"
  >
    Fjern
  </app-ice-button>
  <app-ice-button class="button" color="outlined" matDialogClose testId="abort-remove-seller-button" width="100%">
    Avbryt
  </app-ice-button>
</div>
